import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ColorPickerComponent} from 'ngx-color-picker';

@Component({
  selector: 'app-input-color',
  templateUrl: './input-color.component.html',
})
export class InputColorComponent {

  @Input() parentFormGroup: UntypedFormGroup;
  @Input() parentFormControlName: string;
  @Output() colorChangedEvent: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('colorPickerComponent') colorPickerComponent: ColorPickerComponent;

  colorPicker: string;

  constructor() { }

  get color(): string {
    const colorFormValue = this.parentFormGroup?.get(this.parentFormControlName)?.value;
    if (colorFormValue !== this.colorPicker) {
      this.colorPicker = colorFormValue;
    }
    return colorFormValue;
  }

  colorChanged(color: string) {
    this.parentFormGroup.get(this.parentFormControlName).setValue(color);
    // this.colorPickerComponent?.closeDialog();
    this.colorChangedEvent.emit(color);
  }

}
